import { render, staticRenderFns } from "./business-income-overview.vue?vue&type=template&id=c3a55c38"
import script from "./business-income-overview.vue?vue&type=script&lang=ts"
export * from "./business-income-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports